"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function SmoothReveal({
  open,
  children,
  className,
}: {
  open: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn("smooth-reveal", className)}
      data-open={open ? "true" : undefined}
      aria-hidden={!open}
      inert={!open}
    >
      <div className="smooth-reveal-clip">
        <div className="smooth-reveal-body">{children}</div>
      </div>
    </div>
  );
}
